// ── Theme color constants ────────────────────────────────────────────────
// Three named constants per theme. To change a color app-wide, edit here only.
//
//  PAGE_BG     – body / page background
//  BRAND_NAV   – brand blue used for backgrounds (navbar, gradient headers,
//                numbered badges, purchase buttons)
//  BRAND_TEXT  – brand blue used as a text color (headings, labels, tags)

const THEMES = {
  light: {
    PAGE_BG:    '#f8f9fa',
    BRAND_NAV:  '#1c3a5c',
    BRAND_TEXT: '#1c3a5c',
  },
  dark: {
    PAGE_BG:    '#0d1117',
    BRAND_NAV:  '#0f2a47',
    BRAND_TEXT: '#7eb8f7',
  },
};

/**
 * Apply a theme by name ('light' | 'dark').
 * Sets data-bs-theme on <html> (Bootstrap dark mode) and three CSS custom
 * properties consumed by components throughout the app.
 */
export function applyTheme(themeName) {
  const t = THEMES[themeName] ?? THEMES.light;
  const root = document.documentElement;

  root.setAttribute('data-bs-theme', themeName);
  root.style.setProperty('--theme-page-bg',    t.PAGE_BG);
  root.style.setProperty('--theme-brand-nav',  t.BRAND_NAV);
  root.style.setProperty('--theme-brand-text', t.BRAND_TEXT);

  // Also set body background directly so there is no flash before React mounts.
  document.body.style.backgroundColor = t.PAGE_BG;
}
